import { Component } from 'react'
import withRouter from 'react-router-dom/withRouter'
import { getAccessToken } from '../services/auth'
import { onAuthenticatedRouteChange } from '../services/posthog'

class PostHogTracker extends Component {
  componentDidMount() {
    this.trackRoute(this.props.location.pathname)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.trackRoute(this.props.location.pathname)
    }
  }

  trackRoute(pathname) {
    if (!getAccessToken() || pathname === '/login') return
    onAuthenticatedRouteChange(pathname)
  }

  render() {
    return null
  }
}

export default withRouter(PostHogTracker)
